// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1l2ek","label":"Completed_label__2Lr5p"};